import React, { useState, useEffect, JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    useNotify,
    useRedirect,
    SelectArrayInput,
    BooleanInput,
    useCreate
} from 'react-admin';
import { WorkflowContainer } from "../workflow/WorkflowContainer";
import {
    Box
} from "@mui/material";
import "../workflow/styles/workflow-tabs.scss";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const WorkflowCreate: () => JSX.Element = (): JSX.Element => {
    const [tabNumber, setTabNumber] = useState<number>(0);
    const notify = useNotify();
    const redirect = useRedirect();
    const [create, { isPending, error }] = useCreate();

    function handleTabSelect(num: number): void {
        setTabNumber(num);
    }

    function handleFormSubmit(data: any) {
        console.log(data);

        create(
            'workflows',
            { data: data }
        )
            .then(response => {
                if (!error) {
                    if (localStorage !== undefined) {
                        localStorage.removeItem('create_node_temporary_store_create');
                    }
                }
                notify('Workflow created', { type: 'success' });
                redirect('edit');
                console.log(response);
            })
    }

    return (
        <Create redirect="edit">
            <SimpleForm onSubmit={ handleFormSubmit } >
                <Box className="workflow-container__tabs" >
                    <Box className="tabs__controls" >
                        <Box className={ "tabs__item" + (tabNumber === 0 ? " active" : "") }
                             onClick={ () => handleTabSelect(0) }>
                            <span>{ "Workflow" }</span>
                        </Box>
                        <Box className={ "tabs__item" + (tabNumber === 1 ? " active" : "") }
                             onClick={ () => handleTabSelect(1) }>
                            <span>{ "Create" }</span>
                        </Box>
                    </Box>
                </Box>
                <Box className="tabs__tabs">
                    { (tabNumber === 0) &&
                        <WorkflowContainer mode="create" />
                    }
                    { (tabNumber === 1) &&
                        <>
                            <TextInput name="configuration" source="configuration" fullWidth sx={{
                                display: 'none'
                            }} />
                            <TextInput name="name" source="name" validate={[required()]} fullWidth />
                            <TextInput name="systemCode" source="systemCode" fullWidth />
                            <BooleanInput name="enabled" source="enabled" validate={[required()]} />
                            <BooleanInput name="isSystem" source="isSystem" validate={[required()]} />
                        </>
                    }
                </Box>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
